import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import respondedCircleIcon from '../../images/responded-circle-icon.svg';
import { Card, Paragraph, Theme } from '../../../legacy/hui/src/styled/';

const ShadowCard = Card.extend`
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  min-width: 300px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    min-width: 380px;
  }
`;

const RespondedCircleIcon = styled.div`
    background-image: url('${respondedCircleIcon}');
    position: relative;
    width: 22px;
    height: 22px;
    display: inline-block;
    background-repeat: no-repeat;
    flex-shrink: 0;
    margin-right: 1rem;
`;

const TitleSection = styled(Card.Section)`
  padding: 0.7rem 2rem 0.7rem 0.7rem;
  position: relative;
  display: flex;
  align-items: flex-start;
    padding-left: 1rem;
  }
  span {
    line-height: 22px;
    font-size: 15px;
    color: #00B9BD;
  }
`;

const TextSection = styled(Card.Section)`
  display: inline-block;
  line-height: 20px;
  font-size: 14px;
  color: #555659;
  padding: 1.2rem 3.4rem 1.2rem 3.4rem;
  a {
    color: ${Theme.dark};
  }
`;

export const CloseButton = styled.div`
  right: 0.8rem;
  top: 0.6rem;
  position: absolute;
  cursor: pointer;
`;

export const RespondedCard = ({ categoryPerson, onClose, ...rest }) => (
  <ShadowCard p={0} mt={1} snow {...rest}>
    <TitleSection secondary>
      <CloseButton aria-label="Close" onClick={onClose}>
        <Paragraph m={0} secondary>
          ✕
        </Paragraph>
      </CloseButton>
      <RespondedCircleIcon />
      <span>Your {categoryPerson} has connected!</span>
    </TitleSection>
    <TextSection>{`Expect them to contact you shortly. `}</TextSection>
  </ShadowCard>
);

RespondedCard.propTypes = {
  categoryPerson: PropTypes.string,
  onClose: PropTypes.func,
  style: PropTypes.object
};
